<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="full-screen"
      :loading="detailLoading"
  >
    <template #header>
      {{item.code}}
      <gj-tag
          style="margin-left: 8px;"
          type="plain"
          shape="rectangle"
          :color="item.status | optionColor(inventoryOption)">
        {{ item.status | optionText(inventoryOption) }}
      </gj-tag>
    </template>
    <template #content>
      <div>
        <gj-desc-group label-width="100px">
          <el-row>
            <el-col :span="8">
              <gj-desc label="盘点仓库">{{detailData.warehouseName | defaultShow}}</gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="创建人">{{detailData.createUserName | defaultShow}}</gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="创建时间">{{detailData.createTime | defaultShow}}</gj-desc>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <gj-desc label="备注">{{item.memo | defaultShow}}</gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="处理人">{{detailData.checkUserName | defaultShow}}</gj-desc>
            </el-col>
            <el-col :span="8">
              <gj-desc label="完成时间">{{detailData.completeTime | defaultShow}}</gj-desc>
            </el-col>
          </el-row>
        </gj-desc-group>
      </div>
      <div style="margin-top: 20px">
        <gj-table
            :columns="columns"
            :data="tableData"
            :offset-height="15"
            :index="false"
            :pagination="pagination"
            :loading="loading"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
        >
          <template v-slot:productInfo="{row}">
            <div>
              <gj-text width="100%" :content="row.productName">{{row.productName}}</gj-text>
            </div>
            <div>
              <gj-text width="100%" :content="row.sku">{{row.sku}}</gj-text>
            </div>
          </template>
          <template v-slot:goodCheckResult="{row}">
            <gj-tag
                v-if="row.goodCheckResult !== ''"
                type="plain"
                shape="rectangle"
                :color="row.goodCheckResult | optionColor(countingResultOption)">
              {{ row.goodCheckResult | optionText(countingResultOption) }}
            </gj-tag>
            <template v-if="row.goodCheckResult === ''">
              -
            </template>
          </template>
          <template v-slot:badCheckResult="{row}">
            <gj-tag
                v-if="row.badCheckResult !== ''"
                type="plain"
                shape="rectangle"
                :color="row.badCheckResult | optionColor(countingResultOption)">
              {{ row.badCheckResult | optionText(countingResultOption) }}
            </gj-tag>
            <template v-if="row.badCheckResult === ''">
              -
            </template>
          </template>
        </gj-table>
      </div>
    </template>

  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin} from "../../../../../minxins";
  import {countingResultOption, inventoryOption} from "../enum";
  import {getStorageCheckDetail, getStorageCheckDetailPage} from "../../../../../api/warehouse";
  import {ProductEnum} from "../../../../../utils/options";

  export default {
    name: "inventory-detail",
    mixins: [modalMixIn, queryMixin],
    props: {
      item: null
    },
    created() {
      getStorageCheckDetail(this.item.id)
        .then((data) => {
          this.detailData = data;
        }).complete(() => this.detailLoading = false);
      this.$gjQuery();
    },
    data() {
      return {
        detailLoading: true,
        detailData: {},
        tableData: [],
        columns: [
          {id: 'img', header: '图片', field: 'picture:skuImageUrl', minWidth: '50px'},
          {id: 'productInfo', header: '产品名称/SKU', field: 'slot:productInfo', minWidth: '200px'},
          {id: 'productType', header: '产品类型', field: 'option:productType', minWidth: '100px', options: ProductEnum.typeOption},
          {id: 'currentQuantity', header: '库存良品量', field: 'currentQuantity', minWidth: '100px', align: 'right'},
          {id: 'currentBadQuantity', header: '库存次品量', field: 'currentBadQuantity', minWidth: '100px', align: 'right'},
          {id: 'actualQuantity', header: '实际良品量', field: 'actualQuantity', minWidth: '120px', align: 'right'},
          {id: 'actualBadQuantity', header: '实际次品量', field: 'actualBadQuantity', minWidth: '120px', align: 'right'},
          {id: 'goodDifferenceQuantity', header: '良品量差异值', field: 'goodDifferenceQuantity', minWidth: '120px', align: 'right'},
          {id: 'badDifferenceQuantity', header: '次品量差异值', field: 'badDifferenceQuantity', minWidth: '120px', align: 'right'},
          {id: 'goodCheckResult', header: '良品量盘点结果', field: 'slot:goodCheckResult', minWidth: '120px'},
          {id: 'badCheckResult', header: '次品量盘点结果', field: 'slot:badCheckResult', minWidth: '120px'},
          {id: 'memo', header: '备注', field: 'memo', minWidth: '150px'},
        ],
        countingResultOption: countingResultOption,
        inventoryOption: inventoryOption,
      }
    },
    methods: {
      $gjQuery() {
        this.loading = true;
        this.sort.prop = 'sku';
        getStorageCheckDetailPage({
          model: {
            checkId: this.item.id
          },
          ...this.querySort,
          ...this.queryPagination,
        }).then((data) => {
          this.tableData = data.records;
          this.pagination = this.getPagination(data);
        }).complete(() => this.loading = false)
      }
    }
  }
</script>

<style scoped>

</style>
